/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetDataSharingRequestsDto
 */
export interface GetDataSharingRequestsDto {
    /**
     * Search term for practice name
     * @type {string}
     * @memberof GetDataSharingRequestsDto
     */
    search?: string;
    /**
     * Filter by request status (array)
     * @type {Array<string>}
     * @memberof GetDataSharingRequestsDto
     */
    status?: Array<GetDataSharingRequestsDtoStatusEnum>;
    /**
     * Sort by field
     * @type {string}
     * @memberof GetDataSharingRequestsDto
     */
    sortBy?: GetDataSharingRequestsDtoSortByEnum;
    /**
     * Sort order
     * @type {string}
     * @memberof GetDataSharingRequestsDto
     */
    sortOrder?: GetDataSharingRequestsDtoSortOrderEnum;
    /**
     * Page number (1-based)
     * @type {number}
     * @memberof GetDataSharingRequestsDto
     */
    page?: number;
    /**
     * Number of items per page
     * @type {number}
     * @memberof GetDataSharingRequestsDto
     */
    pageSize?: number;
}


/**
 * @export
 */
export const GetDataSharingRequestsDtoStatusEnum = {
    Requesting: 'requesting',
    ActiveSharing: 'active_sharing',
    Revoked: 'revoked'
} as const;
export type GetDataSharingRequestsDtoStatusEnum = typeof GetDataSharingRequestsDtoStatusEnum[keyof typeof GetDataSharingRequestsDtoStatusEnum];

/**
 * @export
 */
export const GetDataSharingRequestsDtoSortByEnum = {
    Name: 'name',
    Date: 'date'
} as const;
export type GetDataSharingRequestsDtoSortByEnum = typeof GetDataSharingRequestsDtoSortByEnum[keyof typeof GetDataSharingRequestsDtoSortByEnum];

/**
 * @export
 */
export const GetDataSharingRequestsDtoSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetDataSharingRequestsDtoSortOrderEnum = typeof GetDataSharingRequestsDtoSortOrderEnum[keyof typeof GetDataSharingRequestsDtoSortOrderEnum];


/**
 * Check if a given object implements the GetDataSharingRequestsDto interface.
 */
export function instanceOfGetDataSharingRequestsDto(value: object): value is GetDataSharingRequestsDto {
    return true;
}

export function GetDataSharingRequestsDtoFromJSON(json: any): GetDataSharingRequestsDto {
    return GetDataSharingRequestsDtoFromJSONTyped(json, false);
}

export function GetDataSharingRequestsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDataSharingRequestsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'search': json['search'] == null ? undefined : json['search'],
        'status': json['status'] == null ? undefined : json['status'],
        'sortBy': json['sortBy'] == null ? undefined : json['sortBy'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function GetDataSharingRequestsDtoToJSON(json: any): GetDataSharingRequestsDto {
    return GetDataSharingRequestsDtoToJSONTyped(json, false);
}

export function GetDataSharingRequestsDtoToJSONTyped(value?: GetDataSharingRequestsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'search': value['search'],
        'status': value['status'],
        'sortBy': value['sortBy'],
        'sortOrder': value['sortOrder'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

